module.exports = __webpack_public_path__ + "static/media/institute-26-min.08431f5f.webp";